import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';
import { translations } from '../../i18n/translations';

/**
 * Dedicated slide — Kimberley Process.
 * Uses image44 (Kimberley Process official circular seal).
 */
export default function SectionKimberley() {
  const { lang } = useT();
  const T = translations[lang]?.kimberleySlide || translations.de.kimberleySlide;

  return (
    <SectionShell id="kimberley" centerContent className="">
      <div className="grid grid-cols-12 gap-y-14 md:gap-20 items-center">
        <div className="col-span-12 md:col-span-7 order-1">
          <Reveal>
            <div className="overline mb-8 text-lg tracking-[0.32em]">{T.overline}</div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.02] mb-10 text-white">
              {T.title}
            </h2>
            <p className="font-ui text-2xl lg:text-3xl text-white/75 leading-relaxed max-w-[52ch]">
              {T.body}
            </p>
          </Reveal>
        </div>

        <div className="col-span-12 md:col-span-5 order-2">
          <Reveal delay={120}>
            <div
              className="mx-auto relative"
              style={{ width: '100%', maxWidth: 440 }}
              data-testid="kimberley-seal"
            >
              <div
                className="absolute inset-0 rounded-full pointer-events-none"
                style={{
                  background:
                    'radial-gradient(circle at 50% 50%, rgba(220,230,245,0.08) 0%, transparent 65%)',
                  filter: 'blur(20px)',
                }}
              />
              <img
                src="/brand/kimberley-process-logo.webp"
                alt={T.sealAlt}
                loading="lazy"
                className="block w-full h-auto select-none relative"
                draggable={false}
                style={{
                  background: 'transparent',
                  filter: 'drop-shadow(0 14px 26px rgba(0,0,0,0.55)) drop-shadow(0 0 24px rgba(255,255,255,0.10))',
                  opacity: 0.98,
                }}
              />
            </div>
          </Reveal>
        </div>
      </div>
    </SectionShell>
  );
}
